import { QuizDiagnosticsBookGroup } from '../types'

const TAG_ORDER = ['CHE', 'BIO', 'CAR', 'PSY', 'ORG', 'LAB', 'PHY'] as const

export const sortChaptersByTag = (
  data: QuizDiagnosticsBookGroup[]
): QuizDiagnosticsBookGroup[] => {
  const tagOrderMap = TAG_ORDER.reduce<Record<string, number>>(
    (acc, tag, index) => {
      acc[tag] = index
      return acc
    },
    {}
  )

  return [...data].sort((a, b) => {
    const indexA = tagOrderMap[a.tag] ?? Number.POSITIVE_INFINITY
    const indexB = tagOrderMap[b.tag] ?? Number.POSITIVE_INFINITY
    return indexA - indexB
  })
}
